/*------------------------------------*\
    signup
\*------------------------------------*/
module.exports = function(){

    if (!$('.js-register-form').length) {
        return false;
    }


    $('.js-register-form').parsley({
        errorsContainer: function(ParsleyField) {
            var selectWrapper = ParsleyField.$element.closest('.parsley-select-wrapper');
            if (selectWrapper.length > 0) {
                return selectWrapper.find('.parsley-select-errors');
            }
            return ParsleyField;
        }
    });


    if (!bowser.ios) {
        $('.js-register-form').parsley().on('form:validate', function(formInstance){
            //console.dir(formInstance);
            //$('.js-every-modal-wrapper').css('outline', '1px solid red');
            $('.js-every-modal-wrapper').css('height', 'auto');
        });
    }







    var loginUser = function(providedToken, requestData){

        //Cookies.remove('JWT_ACCESS_TOKEN');
        Cookies.set('JWT_ACCESS_TOKEN', providedToken, { expires: 90 });

        var redirectCookie = Cookies.get('LOGIN_SIGNUP_REDIRECT_URI');
        var redirectURI = encodeURIComponent( redirectCookie ? redirectCookie : '/get-fitted/' );
        Cookies.remove('LOGIN_SIGNUP_REDIRECT_URI');

        window.location.replace(location.origin + location.pathname + '?token=' + providedToken
            + '&redirect_uri=' + redirectURI);



        /*
        console.info('Redirecting to: ' + location.origin + location.pathname + '?token=' + providedToken
            + '&redirect_uri=' + encodeURIComponent('/get-fitted/'));
        window.location.replace(location.origin + location.pathname + '?token=' + providedToken
            + '&redirect_uri=' + encodeURIComponent('/get-fitted/'));
        */

    };





    var loginCall = function(requestData) {

        var loginRequestData = {
            Email: requestData.Email,
            password: requestData.Password,
        };

        $.ajax({
            url: EPH_API_URL + '/customers/auth/login',
            type: 'POST',
            data: loginRequestData,
            dataType: 'json',
            complete: function(jqXHR, textStatus){
            },
            success: function(data, textStatus, jqXHR){
                loginUser(data.data.token);
            },
            error: function(jqXHR, textStatus, errorThrown){
            },
        });

    };




    var onSuccess = function(form){

        form.find('.js-form-callback')
            .html('You\'ve signed up successfully! <br />Logging you in...')
            .addClass('is-visible')
            //.addClass('is-success')
            .removeClass('is-error');


        form.find('.js-signup-success-hide').css('height', function(){
            return $(this)[0].scrollHeight;
        });


        setTimeout(function(){
            form.find('.js-signup-success-hide').addClass('is-invisible');
        }, 0);


    };




    var onError = function(form, msg){

        Cookies.remove('JWT_ACCESS_TOKEN');

        form.find('.js-form-callback')
            .text(msg)
            .addClass('is-visible')
            .removeClass('is-success')
            .addClass('is-error');
    };






    $(document).on('submit', '.js-register-form', function(event) {

        event.preventDefault();

        var form = $(this);

        var requestData = form.serializeFormJSON();

        if ( ! form.parsley().isValid() ) {
            return false;
        }


        $('.js-signup-btn').prop('disabled', true);
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: requestData,
            dataType: 'json',
            complete: function(jqXHR, textStatus){
            },
            success: function(data, textStatus, jqXHR){
                onSuccess(form);
                loginCall(requestData);
            },
            error: function(jqXHR, textStatus, errorThrown){
                $('.js-signup-btn').prop('disabled', false);
                onError(form, jqXHR.responseJSON.msg);
            },
        });


    });






}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/signup.js